import { useState } from "react";
import classNames from "classnames";
import { useHistory, useLocation } from "react-router-dom";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { buildQueryParams } from "@ugg/shared/utils/url-query-params";
import { ReactComponent as SearchIcon } from "@ugg/shared/assets/svg/search-icon.svg";

export function LeaderboardSummonerInput({ className }: { className?: string }) {
  const history = useHistory();
  const location = useLocation();
  const queryParams = useQueryString();
  const [input, setInput] = useState("");

  const onSearch = (value: string) => {
    const search = { ...queryParams };
    delete search.page;

    let [inputRiotUserName, inputRiotTagLine] = (value || "").toLowerCase().split("#");
    inputRiotUserName = inputRiotUserName.trim();
    history.push({
      pathname: location.pathname,
      search: buildQueryParams({
        ...search,
        user: value,
      }),
    });
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSearch(input);
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value);
  };

  return (
    <div className={classNames("relative flex items-center", className)}>
      <input
        className={`
          pl-[12px] pr-[34px] w-[300px] h-[36px] rounded-[3px] border-[1px] border-purple-400 bg-purple-400
          text-accent-gray-100 text-[12px] focus:border-accent-blue-400 outline-none
        `}
        placeholder="Search Riot ID"
        type="text"
        onKeyDown={onKeyDown}
        onChange={onChange}
        value={input}
      />
      <SearchIcon className="absolute right-[10px] w-[20px] fill-white cursor-pointer" onClick={() => onSearch(input)} />
    </div>
  );
}
